// Card: the bordered surface. `edge` draws a coloured left edge (needs attention, dealt with);
// `padding` none, sm or md. Ported from the Humint Assistant's components/ui/card.tsx.
import type { ComponentProps } from 'react';
import { cn } from './cn';

export type CardEdge = 'none' | 'accent' | 'signal' | 'success' | 'warning' | 'danger';

const EDGE: Record<CardEdge, string> = {
  none: '',
  accent: 'border-l-4 border-l-accent',
  signal: 'border-l-4 border-l-signal',
  success: 'border-l-4 border-l-success',
  warning: 'border-l-4 border-l-warning',
  danger: 'border-l-4 border-l-danger',
};

const PADDING = { none: '', sm: 'p-3', md: 'p-5' } as const;

export interface CardProps extends Omit<ComponentProps<'div'>, 'ref'> {
  edge?: CardEdge;
  padding?: keyof typeof PADDING;
  as?: 'div' | 'article' | 'section';
}

export function Card({ edge = 'none', padding = 'md', as: As = 'div', className, ...props }: CardProps) {
  return (
    <As
      className={cn('min-w-0 rounded-lg border border-hairline bg-page text-ink-body', EDGE[edge], PADDING[padding], className)}
      {...props}
    />
  );
}
